import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/magic-link')({
  component: MagicLinkLayout,
});

function MagicLinkLayout() {
  return <Outlet />;
}
